import React, { useState, useEffect } from "react";
import "./Result.css";
import Animation from "./Animation/Animation";
import axios from "axios";

export default function Result({ check }) {
  const [branch, setBranch] = useState("");
  const [sem, setSem] = useState("");
  const [result, setResult] = useState([]);
  const [loadingScreen, setLoadingScreen] = useState(true);
  const [step, setStep] = useState("branch"); // branch → sem → result

  // First load animation delay
  useEffect(() => {
    setTimeout(() => setLoadingScreen(false), 2000);
  }, []);

  const handleBranch = (e) => setBranch(e.target.value);
  const handleSem = (e) => setSem(e.target.value);

  const nextToSem = () => branch !== "" && setStep("sem");
  const backToBranch = () => setStep("branch");

  const handleSubmit = () => {
    setStep("loading");

    axios
      .post(
        `${check.state.apiUrl}getResult.php?key=${check.state.publicKey}`,
        { sem, branch },
        check.state.config
      )
      .then((res) => {
        setResult(res.data || []);
        setStep("result");
      });
  };

  const handleReset = () => {
    setStep("branch");
    setBranch("");
    setSem("");
  };

  return (
    <div className="Result">

      {/* FIRST LOAD ANIMATION SCREEN */}
      {loadingScreen && (
        <div className="Result__animation fadeInSmooth">
          <Animation />
          <h4>Please Wait ...</h4>
        </div>
      )}

      {!loadingScreen && (
        <div className="ResultContent fadeInSmooth">

          {/* STEP 1 — Select Branch */}
          {step === "branch" && (
            <div className="result__box">

              <h2 className="title">Udaan – Result Section</h2>
              <p className="desc">Select your branch to continue</p>

              <select className="custom-select" value={branch} onChange={handleBranch}>
                <option value="">Select Branch</option>
                <option value="cse">Computer Science & Engineering</option>
                <option value="ece">Electronics & Communication</option>
                <option value="ee">Electrical Engineering</option>
                <option value="me">Mechanical Engineering</option>
                <option value="ce">Civil Engineering</option>
              </select>

              <button className="btn" onClick={nextToSem} disabled={!branch}>
                Next
              </button>
            </div>
          )}

          {/* STEP 2 — Select Semester */}
          {step === "sem" && (
            <div className="result__box fadeInSmooth">

              <button className="back-btn" onClick={backToBranch}>← Back</button>

              <h2 className="title">Select Semester</h2>

              <select className="custom-select" value={sem} onChange={handleSem}>
                <option value="">Select Semester</option>
                <option value="1">Semester 1</option>
                <option value="2">Semester 2</option>
                <option value="3">Semester 3</option>
                <option value="4">Semester 4</option>
                <option value="5">Semester 5</option>
                <option value="6">Semester 6</option>
                <option value="7">Semester 7</option>
                <option value="8">Semester 8</option>
              </select>

              <button className="btn" onClick={handleSubmit} disabled={!sem}>
                Submit
              </button>
            </div>
          )}

          {/* STEP 3 — Display Result List */}
          {step === "result" && (
            <div className="result__box fadeInSmooth">

              <h2 className="title">Available Results</h2>

              <div className="resultCards">
                {result.map((item, index) => (
                  <div className="resultCard" key={index}>
                    <h3>{item.year}</h3>
                    <p>Sem: {item.sem}</p>

                    <span className="tag">
                      {item.type === "1" ? "Regular" :
                       item.type === "2" ? "Special" : "Backlog"}
                    </span>

                    <a
                      href={`https://recstudentportal.com/ram/${item.path}`}
                      target="_blank"
                      className="downloadBtn"
                    >
                      Download PDF
                    </a>
                  </div>
                ))}
              </div>

              <button className="btn" onClick={handleReset}>Reset</button>
            </div>
          )}

        </div>
      )}
    </div>
  );
}
